import type { Context } from './types.tsx';

// set

export const SET = 'context.SET' as const;
export type SetPayload = Context;
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});
